/// <amd-module name="Wit/MentionsAutocomplete/Utilities/WorkItemAutocompleteUtility" />
import { IWorkItemProviderItem } from '../Providers/IWorkItemProviderItem';
import { getMultiTerms, htmlEncode, SearchBehavior, searchString } from 'Mention/Autocomplete/AutocompleteUtility';

export const DEFAULT_HIGHLIGHT_SUBSTITUTION_PATTERN = `<span class="work-item-autocomplete-highlight">$&</span>`;

export interface IWorkItemHighlighted {
    id: string;
    title: string;
    workItemType: string;
}

export function searchHighlightedWorkItem(
    pattern: string,
    workItem: IWorkItemProviderItem,
    highlightSubstitutionPattern: string = DEFAULT_HIGHLIGHT_SUBSTITUTION_PATTERN
): IWorkItemHighlighted | null {
    const terms = getMultiTerms(pattern, true);
    const idSearchResult = searchString(workItem.id.toString(), terms, SearchBehavior.Prefix, highlightSubstitutionPattern);
    const titleSearchResult = searchString(htmlEncode(workItem.title), terms, SearchBehavior.Contains, highlightSubstitutionPattern);
    const workItemTypeSearchResult = searchString(workItem.workItemType, terms, SearchBehavior.Contains, highlightSubstitutionPattern);

    let allTermsFound: boolean = true;
    terms.forEach(term => {
        const foundTerm = idSearchResult.found[term] || titleSearchResult.found[term] || workItemTypeSearchResult.found[term];
        if (!foundTerm) {
            allTermsFound = false;
        }
    });

    if (allTermsFound) {
        return {
            id: idSearchResult.highlightedSource,
            title: titleSearchResult.highlightedSource,
            workItemType: workItemTypeSearchResult.highlightedSource
        } as IWorkItemHighlighted;
    }

    return null;
}
